import { authorNameMapFromRow, type AuthorRow } from '../../Settings/lists/singleTableListSupport';
import type { BookFormDraft } from './types';

const MN_ID = 'mn';

/** Prefer English, then Mongolian (`mn`), then any other non-empty value in `map`. */
export function localizedTextEnMnThenAny(map: Record<string, string>): string {
  const en = map.en?.trim();
  if (en) return en;
  const mn = map[MN_ID]?.trim();
  if (mn) return mn;
  for (const v of Object.values(map)) {
    const t = typeof v === 'string' ? v.trim() : '';
    if (t) return t;
  }
  return '';
}

/** Line for post-save UI: `Title (Author)` with the same locale priority as titles/names on the form. */
export function bookSaveSuccessTitleAuthorLine(draft: BookFormDraft, authors: AuthorRow[]): string {
  const title = localizedTextEnMnThenAny(draft.name_map);
  const authorRow = authors.find((a) => a.id === draft.author_id);
  const authorName = authorRow ? localizedTextEnMnThenAny(authorNameMapFromRow(authorRow)) : '';
  if (title && authorName) return `${title} (${authorName})`;
  if (title) return title;
  if (authorName) return authorName;
  return '';
}
